import { Component } from '@opten/compiler/metadata/component';
import { hasClass } from '@opten/dom/has-class';
import { toggleClass } from '@opten/dom/toggle-class';
import { ScrollMagicController, ScrollMagicModalController } from '../main';
import { PageRenderHelper } from './page-render-helper';

declare const ScrollMagic: any;
@Component({ className: 'js-invert-target' })
export class InverterComponent {
	private sections: HTMLElement[];

	private scenes: any[];
	private timer: any;

	constructor(private element: HTMLElement) {
		PageRenderHelper.onPageChange.subscribe(() => this.init(true));
		this.init();

		if (!this.timer) {
			this.timer = setInterval(() => {
				if (this.scenes && this.scenes.length > 0) {
					this.scenes.forEach(({ scene, section }) => {
						if (scene.state() == 'DURING') {
							this.toggleInverter(section);
						}
					});
				}
			}, 1000);
		}
	}

	private init(refresh?: boolean) {
		if (this.scenes && this.scenes.length > 0) {
			this.scenes.forEach(({ scene }) => {
				// scene.removeIndicators();
				scene.destroy(false);
			});
		}

		this.scenes = [];
		this.sections = Array.from(
			document.querySelectorAll('.js-invert-listener')
		) as HTMLElement[];

		this.sections.forEach(section => {
			const scene = new ScrollMagic.Scene({
				triggerElement: section,
				triggerHook: 'onLeave',
				offset: (() => {
					const rect = this.element.getBoundingClientRect();
					return (rect.top + rect.height / 2) * -1;
				})(),
				duration: () => {
					return section.clientHeight;
				}
			})
				.on('enter leave', () => {
					if (scene.state() == 'DURING') {
						this.toggleInverter(section);
					}
				})
				// .addIndicators()
				.addTo(section.closest('.js-modal') ? ScrollMagicModalController : ScrollMagicController);
			if (refresh) {
				scene.refresh();
			}
			this.scenes.push({ scene, section });
		});
	}

	private toggleInverter(section) {
		const isModalOpen = hasClass(document.body, 'modal-is-open');
		const isContentOpen = hasClass(document.body, 'content-is-open');
		if (
			section.offsetHeight == 0 ||
			(isModalOpen && !section.closest('.js-modal')) ||
			(isModalOpen == false && section.closest('.js-modal')) ||
			(isContentOpen && isModalOpen == false && !section.closest('.js-section-slider'))
		) {
			return;
		}
		toggleClass(
			this.element,
			'is-inverted',
			section.getAttribute('data-invert').toLowerCase() == 'true'
		);
	}
}
